import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { useLang } from "@/contexts/LangContext";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";
import { Bookmark, ArrowRight } from "lucide-react";

export default function Bookmarks() {
  const { lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/bookmarks").then(({ data }) => setItems(data));
  }, []);

  return (
    <AppShell>
      <div className="editorial-rule pt-4">
        <h1 className="font-display text-4xl">{t(lang,"bookmarks.title")}</h1>
      </div>
      {items.length === 0 ? (
        <div className="mt-8 bg-white border border-[#E9ECEF] p-8 text-[#868E96]" data-testid="bookmarks-empty">{t(lang,"bookmarks.empty")}</div>
      ) : (
        <ul className="mt-8 bg-white border border-[#E9ECEF] divide-y divide-[#E9ECEF]">
          {items.map((a) => (
            <li key={a.article_id}>
              <Link to={`/article/${a.article_id}`} className="flex items-start gap-4 p-5 hover:bg-[#F8F9FA] transition-colors" data-testid={`bookmark-item-${a.article_id}`}>
                <Bookmark className="w-4 h-4 mt-1 text-[#C65D47]" />
                <div className="flex-1">
                  <div className="text-xs tracking-[0.2em] uppercase text-[#868E96]">{a.law_reference}</div>
                  <div className="font-display text-xl mt-1">{a.question?.[lang] || a.question?.en}</div>
                </div>
                <ArrowRight className="w-4 h-4 text-[#868E96]" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </AppShell>
  );
}
